// extracted by mini-css-extract-plugin
export default {"container":"banners-base-banner_container","contentContainer":"banners-base-banner_contentContainer","closeContainer":"banners-base-banner_closeContainer"};